import { put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import { getAuthLink, google, startSync } from './service';
import {
	loginSuccessAction,
	loginFailureAction,
	socialSuccessAction,
	socialFailureAction,
} from './action';
import { getToken, onSignIn, onSignOut } from '../../core/helpers/auth';
import { browserHistory } from '../../App';
import { getUserAction, getUserSuccessAction } from '../User/action';
import { getUser } from '../User/service';
import { getMyTeam, getTeams } from '../MyTeam/service';
import { RESET_USER } from '../User/types';
import { getLastRoute, removeLastRoute } from '../../core/helpers/lastRoute';
import { addCommentAction } from '../Comments/action';

export function* loginSaga(action: any) {
	const { token } = action.payload;
	try {
		yield onSignIn(token);
		const { data }: AxiosResponse = yield getUser();
		yield put(getUserSuccessAction(data.data));
		const route = getLastRoute();
		const comment = localStorage.getItem('comment');
		if (comment) {
			const message = JSON.parse(comment);
			const { firstName, lastName, _id } = data.data;
			const fullName = `${firstName || ''} ${lastName || ''}`;
			message.name = fullName;
			message.userId = _id;
			yield put(addCommentAction({ data: message }));
		}
		removeLastRoute();
		localStorage.removeItem('comment');
		if (route) {
			browserHistory.push(route);
		} else {
			browserHistory.push(data.data.firstLogin ? '/welcome' : '/settings');
		}
	} catch (e) {
		yield put(loginFailureAction(e as Error));
	}
}

export function* autoLoginSaga() {
	try {
		const token: string = yield getToken();
		yield put(loginSuccessAction(token));
		yield put(getUserAction());
	} catch (e) {
		browserHistory.push('/login');
		yield put(loginFailureAction(e as Error));
	}
}

export function* socialSaga(action: any) {
	const { token, callBack, withoutRedirect, inviteToken } = action.payload;
	try {
		const { data } = yield google(token, inviteToken);
		const { user, access_token, refresh_token } = data.data;
		yield onSignIn(access_token);
		yield put(socialSuccessAction(access_token));
		yield put(getUserSuccessAction(user));
		const res: AxiosResponse = yield getMyTeam();
		if (res.data.data) {
			!withoutRedirect && browserHistory.push('/settings');
		} else {
			const teams: AxiosResponse = yield getTeams();
			if (teams.data.data.length) {
				!withoutRedirect && browserHistory.push('/join');
			} else {
				!withoutRedirect && browserHistory.push('/domain-missing');
			}
		}
		yield callBack && callBack(user);
		localStorage.setItem('refresh_token', refresh_token);
	} catch (e) {
		yield callBack && callBack();
		yield put(socialFailureAction(e as Error));
	}
}

export function* getAuthLinkSaga(action: any) {
	const { callBack } = action.payload;
	try {
		const { data }: AxiosResponse = yield getAuthLink();
		callBack(data.data);
	} catch (e) {
		yield put(loginFailureAction(e as Error));
	}
}

export function* startSyncSaga() {
	try {
		yield startSync();
	} catch (e) {
		yield put(loginFailureAction(e as Error));
	}
}

export function* logOutSaga() {
	try {
		yield onSignOut();
		yield put({ type: RESET_USER });
		browserHistory.push('/login');
	} catch (e) {
		yield put(loginFailureAction(e as Error));
	}
}
